import { render, staticRenderFns } from "./g-filters.vue?vue&type=template&id=44f1584a&scoped=true"
import script from "./g-filters.vue?vue&type=script&lang=js"
export * from "./g-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f1584a",
  null
  
)

export default component.exports